import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _CA_TOKEN_MAP, _GENDER_ZH, _IDENTITY_TYPES_ZH, _ERROR_CODE_ZH, _VERIFIER_CODE_ZH;
// export enum CODE_LOGIN {
// ACCESS_TOKEN = 'at',
// REFRESH_TOKEN = 'rt',
// ACCESS_TOKEN_TIMEOUT = 'at-timeout',
// REFRESH_TOKEN_TIMEOUT = 'rt-timeout',
// AT_DIFF_TIME = 'at-diff-time',
// }
export var CA_TYPE;
(function (CA_TYPE) {
  CA_TYPE["FEIXIANG"] = "FEIXIANG";
  CA_TYPE["QLJYZX"] = "QLJYZX";
  CA_TYPE["ZHXXZS"] = "ZHXXZS";
  CA_TYPE["FLYING"] = "FLYING";
})(CA_TYPE || (CA_TYPE = {}));
var CA_TOKEN_MAP = (_CA_TOKEN_MAP = {}, _defineProperty(_CA_TOKEN_MAP, CA_TYPE.FEIXIANG, {
  ACCESS_TOKEN: 'at',
  REFRESH_TOKEN: 'rt',
  ACCESS_TOKEN_TIMEOUT: 'at-timeout',
  REFRESH_TOKEN_TIMEOUT: 'rt-timeout',
  AT_DIFF_TIME: 'at-diff-time'
}), _defineProperty(_CA_TOKEN_MAP, CA_TYPE.QLJYZX, {
  ACCESS_TOKEN: 'at-37',
  REFRESH_TOKEN: 'rt-37',
  ACCESS_TOKEN_TIMEOUT: 'at-timeout-37',
  REFRESH_TOKEN_TIMEOUT: 'rt-timeout-37',
  AT_DIFF_TIME: 'at-diff-time-37'
}), _defineProperty(_CA_TOKEN_MAP, CA_TYPE.ZHXXZS, {
  ACCESS_TOKEN: 'at-31',
  REFRESH_TOKEN: 'rt-31',
  ACCESS_TOKEN_TIMEOUT: 'at-timeout-31',
  REFRESH_TOKEN_TIMEOUT: 'rt-timeout-31',
  AT_DIFF_TIME: 'at-diff-time-31'
}), _defineProperty(_CA_TOKEN_MAP, CA_TYPE.FLYING, {
  ACCESS_TOKEN: 'at-flying',
  REFRESH_TOKEN: 'rt-flying',
  ACCESS_TOKEN_TIMEOUT: 'at-timeout-flying',
  REFRESH_TOKEN_TIMEOUT: 'rt-timeout-flying',
  AT_DIFF_TIME: 'at-diff-time-flying'
}), _CA_TOKEN_MAP);
export var CODE_LOGIN = {
  get ACCESS_TOKEN() {
    var _CA_TOKEN_MAP$CAConfi;
    return (_CA_TOKEN_MAP$CAConfi = CA_TOKEN_MAP[CAConfig.ca]) === null || _CA_TOKEN_MAP$CAConfi === void 0 ? void 0 : _CA_TOKEN_MAP$CAConfi.ACCESS_TOKEN;
  },
  get REFRESH_TOKEN() {
    var _CA_TOKEN_MAP$CAConfi2;
    return (_CA_TOKEN_MAP$CAConfi2 = CA_TOKEN_MAP[CAConfig.ca]) === null || _CA_TOKEN_MAP$CAConfi2 === void 0 ? void 0 : _CA_TOKEN_MAP$CAConfi2.REFRESH_TOKEN;
  },
  get ACCESS_TOKEN_TIMEOUT() {
    var _CA_TOKEN_MAP$CAConfi3;
    return (_CA_TOKEN_MAP$CAConfi3 = CA_TOKEN_MAP[CAConfig.ca]) === null || _CA_TOKEN_MAP$CAConfi3 === void 0 ? void 0 : _CA_TOKEN_MAP$CAConfi3.ACCESS_TOKEN_TIMEOUT;
  },
  get REFRESH_TOKEN_TIMEOUT() {
    var _CA_TOKEN_MAP$CAConfi4;
    return (_CA_TOKEN_MAP$CAConfi4 = CA_TOKEN_MAP[CAConfig.ca]) === null || _CA_TOKEN_MAP$CAConfi4 === void 0 ? void 0 : _CA_TOKEN_MAP$CAConfi4.REFRESH_TOKEN_TIMEOUT;
  },
  get AT_DIFF_TIME() {
    var _CA_TOKEN_MAP$CAConfi5;
    return (_CA_TOKEN_MAP$CAConfi5 = CA_TOKEN_MAP[CAConfig.ca]) === null || _CA_TOKEN_MAP$CAConfi5 === void 0 ? void 0 : _CA_TOKEN_MAP$CAConfi5.AT_DIFF_TIME;
  }
};
export var CAConfig = {
  ca: CA_TYPE.FEIXIANG
};
export function setCA(ca) {
  CAConfig.ca = ca;
}
export var IDENTITY_TYPES;
(function (IDENTITY_TYPES) {
  IDENTITY_TYPES["UNIVERSAL"] = "UNIVERSAL";
  IDENTITY_TYPES["TENANT"] = "TENANT";
  IDENTITY_TYPES["STUDENT"] = "STUDENT";
  IDENTITY_TYPES["TEACHER"] = "TEACHER";
  IDENTITY_TYPES["PARENT"] = "PARENT";
  IDENTITY_TYPES["PROJECT"] = "PROJECT";
  IDENTITY_TYPES["YFD_STAFF"] = "YFD_STAFF";
  IDENTITY_TYPES["YFD_TEMP"] = "YFD_TEMP";
})(IDENTITY_TYPES || (IDENTITY_TYPES = {}));
export var GENDER;
(function (GENDER) {
  GENDER[GENDER["UNKNOW"] = 0] = "UNKNOW";
  GENDER[GENDER["MAN"] = 1] = "MAN";
  GENDER[GENDER["WOMAN"] = 2] = "WOMAN";
})(GENDER || (GENDER = {}));
export var GENDER_LIST = [{
  label: '男',
  value: GENDER.MAN
}, {
  label: '女',
  value: GENDER.WOMAN
}];
export var GENDER_ZH = (_GENDER_ZH = {}, _defineProperty(_GENDER_ZH, GENDER.UNKNOW, '未知'), _defineProperty(_GENDER_ZH, GENDER.MAN, '男'), _defineProperty(_GENDER_ZH, GENDER.WOMAN, '女'), _GENDER_ZH);
export var IDENTITY_TYPES_ZH = (_IDENTITY_TYPES_ZH = {}, _defineProperty(_IDENTITY_TYPES_ZH, IDENTITY_TYPES.STUDENT, '学生'), _defineProperty(_IDENTITY_TYPES_ZH, IDENTITY_TYPES.TEACHER, '教师'), _defineProperty(_IDENTITY_TYPES_ZH, IDENTITY_TYPES.PARENT, '家长'), _IDENTITY_TYPES_ZH);
export var ERROR_CODE;
(function (ERROR_CODE) {
  ERROR_CODE["ERROR"] = "10000";
  ERROR_CODE["WX_CONFLICT_ERROR"] = "1001";
  ERROR_CODE["BAD_REQUEST"] = "40000";
  ERROR_CODE["UNAUTHORIZED"] = "40100";
  ERROR_CODE["NO_PASSWORD"] = "40101";
  ERROR_CODE["REVOKED_TOKEN"] = "40102";
  ERROR_CODE["WRONG_VERIFICATION"] = "40103";
  ERROR_CODE["NEW_PHONE_WRONG_VERIFICATION"] = "40104";
  ERROR_CODE["NO_PERMISSION"] = "403";
  ERROR_CODE["NO_PERMISSION2"] = "1331";
  ERROR_CODE["OVER_FREQ"] = "40300";
  ERROR_CODE["LOGIN_FAIL_OVER_FREQ"] = "40301";
  ERROR_CODE["PHONE_FAIL_OVER_FREQ"] = "40302";
  ERROR_CODE["REFRESH_OVER_FREQ"] = "40303";
  ERROR_CODE["REFRESH_FAIL"] = "40304";
  ERROR_CODE["USER_NOT_FOUND"] = "40400";
  ERROR_CODE["DATA_CONFLICT"] = "40900";
  ERROR_CODE["SERVICE_UNAVAILABLE"] = "50300";
})(ERROR_CODE || (ERROR_CODE = {}));
export var ERROR_CODE_ZH = (_ERROR_CODE_ZH = {}, _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.ERROR, ''), _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.WX_CONFLICT_ERROR, '绑定失败，该账号已绑定其他微信'), _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.BAD_REQUEST, '手机号或密码格式错误'), _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.UNAUTHORIZED, '手机号或密码不正确'), _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.NO_PASSWORD, '手机号或密码不正确'), _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.REVOKED_TOKEN, ''), _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.WRONG_VERIFICATION, '手机号或验证码不正确'), _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.NEW_PHONE_WRONG_VERIFICATION, '手机号或验证码不正确'), _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.NO_PERMISSION, '操作无权限'), _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.NO_PERMISSION2, '操作无权限'), _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.OVER_FREQ, ''), _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.LOGIN_FAIL_OVER_FREQ, '已登录失败5次，为保障您的账号安全，请于 10 分钟后重试'), _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.PHONE_FAIL_OVER_FREQ, '已验证失败5次，为保证您的账号安全，请于 10 分钟后重试'), _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.REFRESH_OVER_FREQ, '请求过于频繁，请稍后再试'), _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.REFRESH_FAIL, '无此学校权限，请联系学校管理员'), _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.USER_NOT_FOUND, '账号不存在，请联系学校管理员'), _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.DATA_CONFLICT, '新手机号已被注册，请重新输入其他手机号或联系学校管理员'), _defineProperty(_ERROR_CODE_ZH, ERROR_CODE.SERVICE_UNAVAILABLE, ''), _ERROR_CODE_ZH);
// node服务，不做用户校验
export var NODE_UNCHECK_USER = 'node-uncheck-user';
export var VERIFIER_CODE;
(function (VERIFIER_CODE) {
  VERIFIER_CODE[VERIFIER_CODE["INVALID"] = 400] = "INVALID";
  VERIFIER_CODE[VERIFIER_CODE["OVER_FREQ"] = 403] = "OVER_FREQ";
  VERIFIER_CODE[VERIFIER_CODE["ERROR"] = 503] = "ERROR";
})(VERIFIER_CODE || (VERIFIER_CODE = {}));
export var VERIFIER_CODE_ZH = (_VERIFIER_CODE_ZH = {}, _defineProperty(_VERIFIER_CODE_ZH, VERIFIER_CODE.INVALID, '手机号非法'), _defineProperty(_VERIFIER_CODE_ZH, VERIFIER_CODE.OVER_FREQ, '请求过于频繁，请稍后再试'), _defineProperty(_VERIFIER_CODE_ZH, VERIFIER_CODE.ERROR, '获取验证码失败，请稍后重试'), _VERIFIER_CODE_ZH);
export var REFRESH_URL;
(function (REFRESH_URL) {
  // 基础认证
  REFRESH_URL["AUTH"] = "/metis-atlas-account/api/auth/refresh";
  // 学生端
  REFRESH_URL["STUDENT"] = "/metis-atlas-account/api/student-auth/refresh";
  // 老师端
  REFRESH_URL["TENANT"] = "/metis-atlas-account/api/select-tenant-auth/refresh";
  // 机构端
  REFRESH_URL["INSTITUTION"] = "/metis-atlas-account/api/institutional-auth/refresh";
})(REFRESH_URL || (REFRESH_URL = {}));
export var PLATFORM;
(function (PLATFORM) {
  PLATFORM["WEB"] = "web";
  PLATFORM["ELECTRON"] = "electron";
})(PLATFORM || (PLATFORM = {}));
export var ACCOUNT_MODE;
(function (ACCOUNT_MODE) {
  ACCOUNT_MODE["ACCOUNT"] = "account";
  ACCOUNT_MODE["STUDENT"] = "student";
})(ACCOUNT_MODE || (ACCOUNT_MODE = {}));
/** 用户登录的类型 */
export var USER_LOGIN_TYPE;
(function (USER_LOGIN_TYPE) {
  /** 普通登录 */
  USER_LOGIN_TYPE["NORMAL"] = "normal";
  /** 代客登录 */
  USER_LOGIN_TYPE["DESIGNATION"] = "designation";
  /** 临时链接代客登录 */
  USER_LOGIN_TYPE["TEMP_LINK"] = "temp-link";
})(USER_LOGIN_TYPE || (USER_LOGIN_TYPE = {}));